<template>
	<div class="container" :class="isOpen ? '' : 'not-expanded'">
		<div class="faq-toggle header" @click="toggle">
			<h4>{{ header }}</h4>
			<font-awesome-icon icon="fa-light fa-chevron-down" size="1x" />
		</div>
		<slide-up-down :model-value="isOpen" :duration="300">
			<div class="faq-content content">
				<div v-parse-links v-html="content" />
			</div>
		</slide-up-down>
	</div>
</template>

<script setup>
const props = defineProps({
	header: { type: String, default: '' },
	content: { type: String, default: '' },
});

const isOpen = defineModel('isOpen', { type: Boolean, default: false });

const emit = defineEmits(['update:isOpen']);

const toggle = () => {
	emit('update:isOpen', !props.isOpen);
};
</script>

<style lang="scss" scoped>
.faq-row {
	width: 96%;
	max-width: 1180px;
	margin: 20px auto 40px;
}

.faq-content {
	padding: 20px 30px;
	font-size: 16px;
}

.faq-toggle {
	cursor: pointer;
	transition: all 0.3s ease-in-out;
	position: relative;
	font-weight: 700;
	padding: 20px 50px 17px 20px;
	border: 1px solid var(--body-color);

	h4 {
		margin: 0;
		font-size: 20px;
	}
}

.not-expanded .faq-toggle {
	border-color: var(--contentblock-background-color);
}

.faq-toggle svg {
	position: absolute;
	right: 24px;
	top: 50%;
	margin-top: -11px;
	color: #000;
	transition: all 0.3s ease-in-out;
	font-weight: 700;
	font-size: 18px;
	transform: rotate(180deg);
}

.not-expanded .faq-toggle svg {
	transform: rotate(0deg);
}

.faq-toggle h3 {
	margin: 0;
	font-size: 18px;
	color: #000;
}

.header {
	cursor: pointer;
	transition: all 0.3s ease-in-out;
}

.container {
	display: inline-block;
	vertical-align: top;
	text-align: left;
	width: 100%;
	overflow: hidden;
	min-height: auto !important ;

	.content {
		transition: all 300ms ease;

		ul,
		ol {
			padding: 0 0 0 20px;
		}
	}

	&.not-expanded .content {
		transform: scaleY(0);
		transform-origin: top;
		opacity: 0;
		height: 0;
		padding: 0 20px;
	}
}

@media (max-width: 880px) {
	.faq-toggle {
		padding: 25px 50px 25px 30px;

		h3 {
			font-size: 20px;
		}
	}
}

@media (max-width: 680px) {
	.faq-toggle {
		padding: 20px 45px 20px 25px;

		h3 {
			font-size: 18px;
		}
	}
}
</style>
